import { capitalize } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader } from "../../Common/Loader";
import { getCurrentPlanType, getPlanIntervalLabel } from "../../Common/utils";
import { ErrorModel } from "../../Model/ErrorModel";
import SelectCardModal from "../../Model/SelectCardModal";
import { SuccessModel } from "../../Model/SuccessModel";
import { WarningModel } from "../../Model/WarningModel";
import { saveCurrentUserData } from "../../Redux/Slice/Common/CurrentUserSlice";
import { sendContactForm } from "../../Redux/Slice/Common/SendContactFormSlice";
import { getPaymentMethodList } from "../../Redux/Slice/PaymentMethod/GetPaymentMethodListSlice";
import { changePlan } from "../../Redux/Slice/Plans/ChangePlanSlice";
import { getPlans } from "../../Redux/Slice/Plans/GetPlansListSlice";
import axiosInstance from "../../Service/Interceptor";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_KEYS } from "../../Config";
import SubscriptionPlanCard from "../../Common/SubscriptionPlanCard";
import { getTopUpPlanList } from "../../Redux/Slice/TopUp/GetTopUpPlanListSlice";
import TopUpPlanCard from "../../Common/TopUpPlanCard";
import { getCountCreditAvailable } from "../../Redux/Slice/Dashboard/CustomerDashboard/GetCountCreditAvailableSlice";

export const BillingComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [confirmModal, setCofirmModal] = useState(false);
  const [selectedPlan, setSelectedPLan] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [credits, setCredits] = useState(0);
  const [paymentType, setPaymentType] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [selectCardModalVisible, setSelectCardModalVisible] = useState(false);
  const currentUserData = useSelector((s) => s?.currentUser?.userData);
  const currentPlanType = getCurrentPlanType(currentUserData);
  const [subscriptionPlansList, setSubscriptionPlansList] = useState([]);
  const [topUpPlansList, setTopUpPlansList] = useState([]);
  const [selectedTab, setSelectedTab] = useState(
    location?.hash == "#topup" ? 2 : 1
  );
  const { userPlanDetailsData } = useSelector((s) => s?.userPlanDetails);

  const userData = JSON.parse(localStorage.getItem("userData"));

  const formatSubscriptionPlanList = (subscriptionPlansList) => {
    if (subscriptionPlansList) {
      if (
        userData &&
        userData.customer &&
        userData.customer.plan &&
        userData?.customer?.plan?.id
      ) {
        let list = [];
        if (subscriptionPlansList && userData.customer) {
          let plan = subscriptionPlansList.filter(
            (plan) => userData?.customer?.plan?.id === plan.id
          );
          if (plan[0]) {
            list.push(plan[0]);
          }
          subscriptionPlansList.map((plan) => {
            if (userData?.customer?.plan?.id != plan.id) {
              list.push(plan);
            }
          });
          list = list?.filter(
            (plan) =>
              !(plan?.isTrial && userData?.customer?.plan?.id !== plan?.id)
          );
          return list;
        }
      } else {
        const list = Array.isArray(subscriptionPlansList)
          ? subscriptionPlansList?.filter(
              (plan) =>
                !(plan?.isTrial && userData?.customer?.plan?.id !== plan?.id)
            )
          : [];
        return list;
      }
    }
    return [];
  };

  const getPlansList = async (page = 1, limit) => {
    setLoading(true);
    const api = selectedTab == 1 ? getPlans : getTopUpPlanList;
    const result = await dispatch(api({ searchText: "", page, limit }));
    if (selectedTab == 1) {
      setSubscriptionPlansList(
        formatSubscriptionPlanList(result?.payload?.data)
      );
    } else {
      setTopUpPlansList(result?.payload?.data?.response);
    }
    setLoading(false);
  };

  useEffect(() => {
    getPlansList();
  }, [selectedTab]);

  const handleChangePlan = (plan) => {
    setSelectedPLan(plan);
    setCofirmModal(true);
  };

  const addTopUp = (plan) => {
    if (userPlanDetailsData) {
      setSelectedPLan(plan);
      setCofirmModal(true);
    } else {
      setLoading(false);
      setErrorMessage("Please purchase subscription first!");
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const contactSales = async () => {
    setLoading(true);
    const result = await dispatch(sendContactForm({}));
    if (
      sendContactForm.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setLoading(false);
      setSuccessModel(true);
      setSuccessMessage("Email send successfully!");
      setTimeout(() => {
        setSuccessModel(false);
      }, 2000);
    } else {
      setLoading(false);
      setErrorModel(true);
      setErrorMessage(
        result?.payload?.error?.message ?? result?.payload?.data?.message
      );
      setTimeout(() => {
        setErrorModel(false);
      }, 2000);
    }
  };

  const onSuccessTopUpPlanChanged = async () => {
    await dispatch(getCountCreditAvailable());
    setLoading(false);
    setSuccessMessage("TopUp Plan Added Successfully!");
    setSuccessModel(true);
    setTimeout(() => {
      setSuccessModel(false);
      navigate("/subscription");
    }, 1500);
  };

  const onSuccessPlanChanged = async () => {
    await dispatch(getCountCreditAvailable());
    let userData = JSON.parse(localStorage.getItem("userData"));
    userData.customer.isPaymentMethodAdded = true;
    userData.customer.plan = selectedPlan;
    localStorage.setItem("userData", JSON.stringify(userData));
    dispatch(saveCurrentUserData(userData));
    setLoading(false);
    setSuccessMessage("Plan Changed Successfully!");
    setSuccessModel(true);
    setTimeout(() => {
      setSuccessModel(false);
      navigate("/subscription");
    }, 1500);
  };

  const changePlanByPaymentMethod = async () => {
    setSelectCardModalVisible(false);
    setCofirmModal(false);
    setLoading(true);
    const planData = {
      customerId: userData?.customer?.id,
      stripeCustomerId: userData?.customer?.stripeCustomerId,
      planId: selectedPlan?.id,
    };
    try {
      const response = await axiosInstance.post(
        "customer/change-plan",
        planData
      );
      const result = response?.data;
      if (result?.success === true) {
        await onSuccessPlanChanged();
      } else {
        setLoading(false);
        setErrorMessage(result?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    } catch (error) {
      if (error?.message?.data?.type === "3D_SECURE_REQUIRED") {
        try {
          // Handle the 3D Secure authentication
          const { paymentIntentId, clientSecret } = error?.message.data;
          const stripe = await loadStripe(STRIPE_KEYS.STRIPE_PUBLISHABLE_KEY);
          const result = await stripe.confirmCardPayment(clientSecret);

          if (result.error) {
            setLoading(false);
            setErrorMessage(result.error.message);
            setErrorModel(true);
            setTimeout(() => {
              setErrorModel(false);
            }, 1500);
            return {
              success: false,
              message: result.error.message,
            };
          }

          // After successful 3D Secure authentication, confirm the payment
          const confirmationResponse = await axiosInstance.post(
            "customer/confirm-3d-secure",
            {
              paymentIntentId: paymentIntentId,
              planId: planData.planId,
              customerId: planData.customerId,
            }
          );

          await onSuccessPlanChanged();
          return confirmationResponse.data;
        } catch (confirmError) {
          setLoading(false);
          setErrorMessage(
            confirmError.message || "Payment authentication failed"
          );
          setErrorModel(true);
          setTimeout(() => {
            setErrorModel(false);
          }, 1500);

          return {
            success: false,
            message: confirmError.message || "Payment authentication failed",
          };
        }
      }
      setLoading(false);
      setErrorMessage("Payment authentication failed");
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);

      return {
        success: false,
        message: "Payment authentication failed",
      };
    }
  };

  const addTopUpPlanByPaymentMethod = async () => {
    setSelectCardModalVisible(false);
    setCofirmModal(false);
    setLoading(true);
    const planData = {
      customerId: userData?.customer?.id,
      stripeCustomerId: userData?.customer?.stripeCustomerId,
      planId: selectedPlan?.id,
    };
    try {
      const response = await axiosInstance.post(
        "customer/buy-topup-plan",
        planData
      );
      const result = response?.data;
      if (result?.success === true) {
        await onSuccessTopUpPlanChanged();
      } else {
        setLoading(false);
        setErrorMessage(result?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    } catch (error) {
      if (error?.message?.data?.type === "3D_SECURE_REQUIRED") {
        try {
          // Handle the 3D Secure authentication
          const { paymentIntentId, clientSecret } = error?.message.data;
          const stripe = await loadStripe(STRIPE_KEYS.STRIPE_PUBLISHABLE_KEY);
          const result = await stripe.confirmCardPayment(clientSecret);

          if (result.error) {
            setLoading(false);
            setErrorMessage(result.error.message);
            setErrorModel(true);
            setTimeout(() => {
              setErrorModel(false);
            }, 1500);
            return {
              success: false,
              message: result.error.message,
            };
          }

          // After successful 3D Secure authentication, confirm the payment
          const confirmationResponse = await axiosInstance.post(
            "customer/confirm-3d-secure",
            {
              paymentIntentId: paymentIntentId,
              planId: planData.planId,
              customerId: planData.customerId,
              isTopupPayment: true,
            }
          );

          await onSuccessTopUpPlanChanged();
          return confirmationResponse.data;
        } catch (confirmError) {
          setLoading(false);
          setErrorMessage(
            confirmError.message || "Payment authentication failed"
          );
          setErrorModel(true);
          setTimeout(() => {
            setErrorModel(false);
          }, 1500);

          return {
            success: false,
            message: confirmError.message || "Payment authentication failed",
          };
        }
      }
      setLoading(false);
      setErrorMessage("Payment authentication failed");
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);

      return {
        success: false,
        message: "Payment authentication failed",
      };
    }
  };

  const handleCancel = () => {
    setCofirmModal(false);
  };

  const getCardList = async () => {
    setCofirmModal(false);
    if (!location.pathname.includes("subscription")) {
      navigate("/payment");
      return;
    }
    setLoading(true);
    try {
      const result = await dispatch(
        getPaymentMethodList({ searchText: "", page: 1, limit: 200 })
      );
      if (
        getPaymentMethodList.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        const data = Array.isArray(result?.payload.data)
          ? result.payload.data
          : [];
        const defaultPaymentMethod = data?.some((card) => card.isDefault);
        if (defaultPaymentMethod) {
          if (selectedTab == 2) {
            addTopUpPlanByPaymentMethod();
          } else {
            await changePlanByPaymentMethod();
          }
          return;
        } else if (data.length > 0) {
          setSelectCardModalVisible(true);
          return;
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
    navigate(selectedTab == 2 ? "/topup-payment" : "/subscription-payment", {
      state: { plan: selectedPlan },
    });
  };

  return (
    <>
      {isLoading ? <Loader /> : ""}
      {confirmModal ? (
        <WarningModel
          isTopup={selectedTab == 2}
          onAccept={getCardList}
          onReject={handleCancel}
        />
      ) : (
        ""
      )}
      {selectCardModalVisible ? (
        <SelectCardModal
          changePlanByPaymentMethod={
            selectedTab == 2
              ? addTopUpPlanByPaymentMethod
              : changePlanByPaymentMethod
          }
          handleCancel={() => setSelectCardModalVisible(false)}
        />
      ) : null}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      <div className="page__body">
        <div className="tabsWrap">
          <ul className="tabs">
            <li
              className={
                selectedTab === 1
                  ? "tabs__link tabs__link--selected"
                  : "tabs__link"
              }
              onClick={() => {
                setSelectedTab(1);
                navigate("#subscription");
              }}
            >
              Subscription Plans
            </li>
            <li
              className={
                selectedTab === 2
                  ? "tabs__link tabs__link--selected"
                  : "tabs__link"
              }
              onClick={() => {
                setSelectedTab(2);
                navigate("#topup");
              }}
            >
              Topup Plans
            </li>
          </ul>
        </div>
        <div className="tabsContent">
          <div className="tabsContent__content tabsContent__content--selected">
            <div className="plansWrap" style={{ marginTop: 20 }}>
              {currentPlanType === "enterprise" && selectedTab === 1 ? (
                <div className="btn__group btn__group--end w_100">
                  <button className="btn btn__primary" onClick={contactSales}>
                    Contact Sales
                  </button>
                </div>
              ) : null}
              <div
                className={
                  location.pathname.includes("subscription")
                    ? "plansWrap__list"
                    : "plansWrap__list"
                }
              >
                {selectedTab == 1 &&
                Array.isArray(subscriptionPlansList) &&
                subscriptionPlansList?.length ? (
                  subscriptionPlansList.map((plan) => (
                    <SubscriptionPlanCard
                      plan={plan}
                      isCurrentPlan={userData?.customer?.plan?.id === plan?.id}
                      handleChangePlan={handleChangePlan}
                    />
                  ))
                ) : selectedTab == 2 &&
                  Array.isArray(topUpPlansList) &&
                  topUpPlansList?.length ? (
                  topUpPlansList.map((plan) => (
                    <TopUpPlanCard
                      plan={plan}
                      isCurrentPlan={userData?.customer?.plan?.id === plan?.id}
                      addTopUp={addTopUp}
                    />
                  ))
                ) : (
                  <div className="no-data">
                    No {selectedTab == 1 ? "Subscription Plan" : "Topup Plan"}{" "}
                    Found!
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
